import { useEffect } from "react"
import { garconClient } from "@apis/axiosClients"
import { getApiErrorMessage } from "@utils/apiError"

// Normalises every rejection into the message the user reads, so that callers can
// interpolate the error directly. Registered last, after the interceptors that
// reject with a message of their own.
export const useApiErrorInterceptor = () => {
  useEffect(() => {
    const resInterceptor = garconClient.interceptors.response.use(
      function onFulfilled(response) {
        return response
      },
      function onRejected(error) {
        return Promise.reject(getApiErrorMessage(error))
      },
    )

    return () => {
      garconClient.interceptors.response.eject(resInterceptor)
    }
  }, [])
}
